define(['./findElements'],
	function(findElements) {

        function findFirstElement(selector){
            var elements = findElements(selector);
            return (elements && elements.length)?elements[0]:null;
        }

        function findPropertyValue(property, lookUp) {
            return function(text, render) {
                var element = findFirstElement(render(text)),
                    result = element?element[property]:undefined;
                if(lookUp){
                    while(result == undefined && element){
                        result = element[property];
                        element = element.parentNode;
                    }
                }   
                return result;
            }
        }

        function findAttrValue() {
            return function(text, render) {
                var textParts = render(text).split("|"),
                    selector = textParts[0],
                    property = textParts[1],
                    result = null;
                if(selector && property){
                    var element = findFirstElement(selector);
                    result = element[property];
                }    
                return result;
            }
        }

        function findElementsString() {
            return function(text, render) {
                return 'window.uResponses.findElements("' + render(text) + '")';
            }
        }

        var elementContext = {
            innerText: findPropertyValue.bind(undefined, "innerText"),
            textContent: findPropertyValue.bind(undefined, "textContent"),
            value: findPropertyValue.bind(undefined, "value"),
            label: findPropertyValue.bind(undefined, "label"),
            href: findPropertyValue.bind(undefined, "href", true),
            attr: findAttrValue,
            find: findElementsString
        }

        var preprocessString = function(value,  options, render){
            var context = {
                window: window,
                event: options.triggeringEvent,
                element: elementContext,
                triggeringEvent: options.triggeringEvent
            }
            var result = render(value, context)
            return result
        }

        var preprocessOptions = function(options, render){
            var result = true;
            for(var key in options){
                var value = options[key]
                if(typeof value === 'string'){
                    value = preprocessString(value, options, render)
                    if(value.indexOf("{{") != -1){
                        result = false; 
                    }
                    options[key] = value
                }/*else if(key === 'selectors'){
                    for (var i = 0; i<options[key].length){
                        value = options[key][i];
                        value = preprocessString(value, options, render)
                        if(value.indexOf("{{") != -1){
                            result = false; 
                        }
                    }
                }*/
            }     
            return result
        }

		return preprocessOptions;
	}
);





//////////////////
// WEBPACK FOOTER
// ./utils/preprocessOptions.js
// module id = 47
// module chunks = 0